import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';
import Stack, { contentStackSpacing } from '../../../../../v2BaseComponents/Stack';
import Text from '../../../../../v2BaseComponents/Text';
import MaxWidthRestrictedContent from '../../../../../v2BaseComponents/MaxWidthRestrictedContent';
import { mainContentPadding } from '../../../../../v2BaseComponents/MainContentContainer';
import Divider from '../../../../../v2BaseComponents/Divider';
import Button from '../../../../../v2BaseComponents/Button';
import { useDownloadTemplate } from './useDownloadTemplate';
import { BulkAddClientRecord } from '../types';
import { useUploadCSV } from './useUploadCSV';

const intl = getIntl('bulkAddClientRecordsScreen-pendingFileContent', {
    title: 'Bulk Add Client Records',
    subtitle:
        'Easily add multiple client records at once.  Once uploaded, you will be able to review and edit the records before adding them to your organization',
    step1: '1. Download the template',
    downloadTemplate: 'Download Template',
    step2: '2. Fill out the template with your client records',
    step3: '3. Upload the completed template (as a .csv file)',
    uploadData: 'Upload File',
});

export type PendingFileContentOwnProps = {
    onUpload: (csvData: BulkAddClientRecord[]) => void;
};

export type PendingFileContentProps = PendingFileContentOwnProps;

const PendingFileContent: React.FC<PendingFileContentProps> = (props) => {
    const { downloadTemplate } = useDownloadTemplate();
    const { onPress, E2EInput } = useUploadCSV({ onUpload: props.onUpload });
    return (
        <ActionButtonLayout scrollable whiteBackground>
            <MaxWidthRestrictedContent variant="xs">
                <Stack
                    vertical
                    fullWidth
                    space={contentStackSpacing}
                    align="center"
                    style={{ padding: mainContentPadding }}
                >
                    <Text variant="bold-h4" alignText="center">
                        {intl('title')}
                    </Text>
                    <Text variant="body-1" alignText="center">
                        {intl('subtitle')}
                    </Text>
                    <Stack vertical align="center" space={20} fullWidth>
                        <Divider horizontal />
                        <Stack vertical align="center" space={1} style={{ width: 320 }}>
                            <Text variant="bold-body-1">{intl('step1')}</Text>
                            <Button
                                size="lg"
                                leftIcon="Download"
                                variant="secondary"
                                title={intl('downloadTemplate')}
                                onPress={() => {
                                    downloadTemplate();
                                }}
                                testID="download-template-button"
                            />
                        </Stack>
                        <Text variant="bold-body-1">{intl('step2')}</Text>
                        <Stack vertical align="center" space={1} style={{ width: 320 }}>
                            <Text variant="bold-body-1">{intl('step3')}</Text>
                            <>
                                <Button
                                    size="lg"
                                    leftIcon="Upload"
                                    variant="primary"
                                    title={intl('uploadData')}
                                    onPress={onPress}
                                />
                                {E2EInput}
                            </>
                        </Stack>
                    </Stack>
                </Stack>
            </MaxWidthRestrictedContent>
        </ActionButtonLayout>
    );
};

export default React.memo(PendingFileContent);
